/*@ngInject*/
const ClassCodeRepository = function (baseCachedRepository) {

    angular.extend(this, baseCachedRepository);

    this.getCacheName = function () {
        return 'classCodeRepository';
    };

    this.getCacheCapacity = function () {
        return 10;
    };

    this.getClassCodeItems = function (type, query, effectiveDate) {
        let url = '/rest/ClassCode',
            config = {
                params: {
                    classCodeType: type,
                    searchString: query,
                    effectiveDate: moment(effectiveDate).utc().format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS)
                }
            },
            cacheKey = type + query;

        return this.get(cacheKey, url, config);
    };

    this.getClassCodeGroupings = function (type, effectiveDate) {
        let url = '/rest/ClassCode/Groupings',
            config = {
                params: {
                    classCodeType: type,
                    effectiveDate: moment(effectiveDate).utc().format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS)
                }
            },
            cacheKey = type + effectiveDate;

        return this.get(cacheKey, url, config);
    };

    this.processResponseData = function (responseData) {
        _.map(responseData, function (item) {
            item.value = item.description;
            item.description = (!_.isNil(item.codeDisplayText) ? item.codeDisplayText : item.code) + ' - ' + item.value;
            return item;
        });

        return responseData;
    };
};

angular.module('umFormViewer')
    .service('classCodeRepository', ClassCodeRepository);
